import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { ImportUserGroupIdsByCsvForm } from '../../../../../../components/ImportUserGroupIdsByCsvForm.tsx'

const Page = (): ReactElement => {
  const { organizationId } = Route.useParams()

  return <ImportUserGroupIdsByCsvForm organizationId={organizationId} />
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/user_groups/csv')({
  component: Page,
})
